var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.isLoading)?_c('div',{staticClass:"recently-active"},[_c('div',{staticClass:"recently-active__title-wrapper"},[_c('h6',{staticClass:"recently-active__title"},[_vm._v(" Other courses in "+_vm._s(_vm.learningPath.name)+" ")])]),_c('Swiper',{staticClass:"recently-active__swiper",attrs:{"parentClass":`recently-active__active-courses`,"swiperOptions":_vm.swiperOptions,"disabled":_vm.courses.length <= 4},on:{"slide-changed":_vm.handleSlideChange,"first-slide":_vm.handleSlideChange}},_vm._l((_vm.courses),function(course,i){return _c('div',{key:course.uuid,class:[
        'swiper-slide',
        'recently-active__tile-wrapper',
        i === 0 &&
          _vm.isFirstSlideActive &&
          'recently-active__tile-wrapper--first',
      ]},[_c('CourseTile',{attrs:{"height":386,"course":{
          ...course,
          id: course.uuid,
          learning_areas: [{ name: _vm.getLearningArea() }],
        },"isFreeTrialUser":false}})],1)}),0)],1):_c('div',{staticClass:"recently-active recently-active__loader"},[_c('ActionLoader')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }